var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 16L9 9L2 2","stroke":"currentColor","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Chevron.defaultProps = {"width":"11","height":"18","viewBox":"0 0 11 18","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
